export default function Silhouette({ progress = 0 }) {
  const shapeHeight = 430;
  // Clip from the top of the shape downward
  const clipTop = shapeHeight * (progress / 100);

  return (
    <div style={{ width: "119px", height: "430px", position: "relative" }}>
      
      {/* Empty Silhouette */}
      <img
        src="/assets/Silhouette/silhouette-empty.svg"
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
        }}
      />

      {/* Filled Silhouette */}
      <img
        src="/assets/Silhouette/silhouette-full.svg"
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          clipPath: `inset(${clipTop}px 0 0 0)`,
          transition: "clip-path 0.6s ease",
        }}
      />

    </div>
  );
}
